/* AUTOPRIME: interações das seções .ap-* (módulo, sem dependências externas).
   Integração com o carrinho do tema: dispara CartLinesUpdateEvent (@shopify/events),
   o mesmo evento que o formulário de produto nativo usa, para o drawer, o contador e a
   página do carrinho se atualizarem sozinhos. */

const root = document.documentElement;
root.classList.add('ap-js');
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const mqMobile = window.matchMedia('(max-width: 749px)');
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
const money = (cents) => {
  const fmt = window.Shopify?.currency?.active === 'BRL' || !window.Shopify?.currency ? { style: 'currency', currency: 'BRL' } : { style: 'currency', currency: window.Shopify.currency.active };
  return new Intl.NumberFormat('pt-BR', fmt).format(cents / 100);
};

/* ---------- reveal ---------- */
function initReveal(scope = document) {
  const els = $$('[data-ap-reveal]:not(.is-in)', scope);
  if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach((el) => el.classList.add('is-in')); return; }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
  els.forEach((el) => io.observe(el));
}

/* ---------- barra de anúncios ---------- */
function initAnnouncements(scope = document) {
  $$('[data-ap-announce]', scope).forEach((bar) => {
    if (bar.dataset.apReady) return; bar.dataset.apReady = '1';
    const items = $$('.ap-announce__item', bar);
    if (items.length < 2) return;
    let i = 0, timer = null;
    const speed = Number(bar.dataset.speed) || 5000;
    const show = (n) => {
      items[i].classList.remove('is-active'); items[i].setAttribute('aria-hidden', 'true');
      i = (n + items.length) % items.length;
      items[i].classList.add('is-active'); items[i].removeAttribute('aria-hidden');
    };
    const play = () => { stop(); timer = setInterval(() => show(i + 1), speed); };
    const stop = () => clearInterval(timer);
    $('[data-ap-announce-next]', bar)?.addEventListener('click', () => { show(i + 1); play(); });
    $('[data-ap-announce-prev]', bar)?.addEventListener('click', () => { show(i - 1); play(); });
    bar.addEventListener('mouseenter', stop); bar.addEventListener('mouseleave', play);
    bar.addEventListener('focusin', stop); bar.addEventListener('focusout', play);
    play();
  });
}

/* ---------- header ---------- */
function initHeader() {
  const header = $('[data-ap-header]');
  if (!header) return;
  const setH = () => {
    const h = header.offsetHeight;
    document.body.style.setProperty('--ap-header-live-h', h + 'px');
    document.body.style.setProperty('--header-height', h + 'px');
  };
  setH();
  if ('ResizeObserver' in window) new ResizeObserver(setH).observe(header);
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => { header.classList.toggle('is-scrolled', window.scrollY > 4); ticking = false; });
  }, { passive: true });
}

function initDrawers() {
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-ap-drawer-open]');
    if (opener) {
      const d = document.getElementById(opener.dataset.apDrawerOpen);
      if (d) { openDrawer(d, opener); e.preventDefault(); }
      return;
    }
    const closer = e.target.closest('[data-ap-drawer-close]');
    if (closer) closeDrawer(closer.closest('[data-ap-drawer], .ap-facets'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-ap-drawer].is-open, .ap-facets.is-open').forEach((d) => closeDrawer(d));
  });
}
function openDrawer(d, opener) {
  d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
  d._apOpener = opener || document.activeElement;
  opener?.setAttribute('aria-expanded', 'true');
  document.body.classList.add('ap-lock');
  setTimeout(() => $('a, button, input, select, summary', d.querySelector('[role=dialog], .ap-facets__panel') || d)?.focus(), 60);
}
function closeDrawer(d) {
  if (!d) return;
  d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('ap-lock');
  d._apOpener?.setAttribute('aria-expanded', 'false');
  d._apOpener?.focus?.();
}

/* ---------- rodapé: colunas recolhidas no mobile ---------- */
function initFooter() {
  const cols = $$('[data-ap-footer-col]');
  const sync = () => cols.forEach((c) => { if (mqMobile.matches) c.removeAttribute('open'); else c.setAttribute('open', ''); });
  sync();
  mqMobile.addEventListener?.('change', sync);
}

/* ---------- carrosséis ---------- */
function initCarousels(scope = document) {
  $$('[data-ap-carousel]', scope).forEach((c) => {
    if (c.dataset.apReady) return; c.dataset.apReady = '1';
    const track = $('[data-ap-track]', c);
    const prev = $('[data-ap-prev]', c), next = $('[data-ap-next]', c), bar = $('[data-ap-bar]', c);
    if (!track) return;
    const step = () => track.clientWidth * 0.9;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      if (bar) {
        bar.style.width = Math.max(ratio * 100, 8) + '%';
        bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * ((1 / Math.max(ratio, 0.08)) - 1) * 100 : 0}%)`;
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      const nav = $('.ap-carousel__nav', c);
      if (nav) nav.style.display = max <= 2 && !$('.ap-link', nav) ? 'none' : '';
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  });
}

/* ---------- hero (slideshow) ---------- */
function initHero(scope = document) {
  $$('[data-ap-hero]', scope).forEach((hero) => {
    if (hero.dataset.apReady) return; hero.dataset.apReady = '1';
    const slides = $$('[data-ap-hero-slide]', hero), dots = $$('[data-ap-hero-dot]', hero);
    if (slides.length < 2) return;
    const delay = reduceMotion ? 0 : Number(hero.dataset.autoplay) || 0;
    hero.style.setProperty('--ap-hero-speed', delay ? delay + 'ms' : '0.4s');
    let i = 0, timer = null;
    const go = (n) => {
      slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true'); slides[i].inert = true;
      dots[i]?.removeAttribute('aria-current');
      i = (n + slides.length) % slides.length;
      const s = slides[i];
      s.classList.add('is-active'); s.removeAttribute('aria-hidden'); s.inert = false;
      s.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      if (dots[i]) { void dots[i].offsetWidth; dots[i].setAttribute('aria-current', 'true'); }
    };
    const stop = () => clearInterval(timer);
    const play = () => { stop(); if (delay) timer = setInterval(() => go(i + 1), delay); };
    $('[data-ap-hero-next]', hero)?.addEventListener('click', () => { go(i + 1); play(); });
    $('[data-ap-hero-prev]', hero)?.addEventListener('click', () => { go(i - 1); play(); });
    dots.forEach((d, n) => d.addEventListener('click', () => { go(n); play(); }));
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', stop); hero.addEventListener('focusout', play);
    let x0 = null;
    hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1);
      play();
    }, { passive: true });
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
    play();
  });
}

/* ---------- guia de produtos ---------- */
function initGuides(scope = document) {
  $$('[data-ap-guide]', scope).forEach((g) => {
    if (g.dataset.apReady) return; g.dataset.apReady = '1';
    const slides = $$('[data-ap-slide]', g), dots = $$('[data-ap-guide-dot]', g);
    if (slides.length < 2) return;
    let i = 0;
    const go = (n) => {
      slides[i].classList.remove('is-active'); dots[i]?.removeAttribute('aria-current');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); dots[i]?.setAttribute('aria-current', 'true');
    };
    $('[data-ap-guide-prev]', g)?.addEventListener('click', () => go(i - 1));
    $('[data-ap-guide-next]', g)?.addEventListener('click', () => go(i + 1));
    dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
    let x0 = null;
    g.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    g.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
  });
}

/* ---------- preço dos cards ao trocar a variante ---------- */
function renderPrice(box, price, compare) {
  const now = $('[data-ap-now]', box); if (now) now.textContent = money(price);
  const cmpWrap = $('.ap-price__compare', box), off = $('.ap-price__off', box);
  if (compare > price) {
    const pct = Math.round(((compare - price) / compare) * 100);
    if (cmpWrap) { cmpWrap.hidden = false; $('[data-ap-compare]', cmpWrap).textContent = money(compare); }
    if (off) { off.hidden = false; off.textContent = `-${pct}%`; }
  } else { if (cmpWrap) cmpWrap.hidden = true; if (off) off.hidden = true; }
  const pix = $('[data-ap-pix]', box);
  if (pix) { const pct = Number(pix.dataset.apPix) || 0; $('b', pix).textContent = money(Math.floor((price * (100 - pct)) / 100)); }
  const inst = $('[data-ap-inst]', box);
  if (inst) {
    const max = Number(inst.dataset.apInst), min = Number(inst.dataset.apInstMin) || 500;
    const n = Math.min(max, Math.floor(price / min));
    inst.hidden = n < 2;
    if (n >= 2) inst.textContent = `ou ${n}x de ${money(Math.floor(price / n))}${inst.dataset.apInstFree ? ' sem juros' : ''}`;
  }
}
document.addEventListener('change', (e) => {
  const sel = e.target.closest?.('[data-ap-variant]');
  if (!sel) return;
  const opt = sel.selectedOptions[0];
  const card = sel.closest('[data-ap-card]');
  const box = card && $('[data-ap-price]', card);
  if (box && opt) renderPrice(box, Number(opt.dataset.price), Number(opt.dataset.compare));
});

/* ---------- adicionar ao carrinho (cards, kits, produto herói) ---------- */
let eventsModule = null;
async function getEvents() {
  if (eventsModule !== null) return eventsModule;
  try { eventsModule = await import('@shopify/events'); } catch { eventsModule = false; }
  return eventsModule;
}
function formItems(form) {
  const fd = new FormData(form);
  const items = [];
  const byIdx = {};
  for (const [k, v] of fd.entries()) {
    const m = k.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
    if (m) { byIdx[m[1]] = byIdx[m[1]] || {}; byIdx[m[1]][m[2]] = Number(v); }
  }
  Object.keys(byIdx).sort((a, b) => a - b).forEach((k) => { if (byIdx[k].id) items.push({ id: byIdx[k].id, quantity: byIdx[k].quantity || 1 }); });
  if (!items.length && fd.get('id')) items.push({ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 });
  return items;
}
function flash(btn, cls, text, ms = 1800) {
  const label = btn.dataset.apLabel || btn.textContent.trim();
  const html = btn.innerHTML;
  btn.classList.remove('is-loading'); btn.classList.add(cls); btn.textContent = text;
  setTimeout(() => { btn.classList.remove(cls); btn.innerHTML = html; btn.disabled = false; }, ms);
  return label;
}
async function addToCart(form, btn) {
  const items = formItems(form);
  if (!items.length) return;
  btn.disabled = true; btn.classList.add('is-loading');
  const sectionIds = $$('cart-items-component').map((c) => c.dataset.sectionId).filter(Boolean);
  const ev = await getEvents();
  let deferred = null;
  if (ev && ev.CartLinesUpdateEvent) {
    try {
      deferred = ev.CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new ev.CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
        promise: deferred.promise,
      }));
    } catch (err) { deferred = null; }
  }
  try {
    const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: sectionIds.join(','), sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Não foi possível adicionar.');
    const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    if (deferred) {
      deferred.resolve({
        cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: data.items || [], sections: data.sections || {}, itemCount: items.reduce((a, b) => a + b.quantity, 0), source: 'autoprime', didError: false },
      });
    } else if (!document.getElementById('cart-drawer')) {
      window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
      return;
    }
    updateCartTotal(cart);
    flash(btn, 'is-added', 'Adicionado ✓');
    const drawer = document.getElementById('cart-drawer');
    const auto = $('cart-drawer-component[auto-open]');
    if (drawer && !auto && typeof drawer.open === 'function') setTimeout(() => drawer.open(), 250);
  } catch (err) {
    deferred?.reject?.(err);
    btn.classList.remove('is-loading'); btn.disabled = false;
    let msg = form.querySelector('.ap-form-error');
    if (!msg) { msg = document.createElement('p'); msg.className = 'ap-form-error'; msg.setAttribute('role', 'alert'); msg.style.cssText = 'margin-top:8px;font-size:12px;color:#b80500'; form.appendChild(msg); }
    msg.textContent = err.message || 'Não foi possível adicionar ao carrinho.';
  }
}
document.addEventListener('submit', (e) => {
  const form = e.target.closest?.('form[data-ap-add]');
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('button[type=submit]');
  if (btn) addToCart(form, btn);
});

/* ---------- total do carrinho no header ---------- */
function updateCartTotal(cart) {
  $$('[data-ap-cart-total]').forEach((el) => { el.textContent = money(cart.total_price); });
}
(async () => {
  const ev = await getEvents();
  if (!ev?.StandardEvents?.cartLinesUpdate) return;
  document.addEventListener(ev.StandardEvents.cartLinesUpdate, (e) => {
    e.promise?.then(({ cart }) => {
      if (cart && typeof cart.cost?.totalAmount?.amount !== 'undefined') {
        $$('[data-ap-cart-total]').forEach((el) => { el.textContent = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: cart.cost.totalAmount.currencyCode || 'BRL' }).format(Number(cart.cost.totalAmount.amount)); });
      } else {
        fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then((r) => r.json()).then(updateCartTotal).catch(() => {});
      }
    }).catch(() => {});
  });
  /* blocos AutoPrime da PDP acompanham a troca de variante (HTML novo vem no evento) */
  if (ev.StandardEvents.productSelect) {
    document.addEventListener(ev.StandardEvents.productSelect, (e) => {
      e.promise?.then(({ detail }) => {
        if (!detail?.html) return;
        $$('[data-ap-pdp-block]').forEach((el) => {
          const fresh = detail.html.querySelector(`[data-ap-pdp-block="${el.dataset.apPdpBlock}"]`);
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
      }).catch(() => {});
    }, true);
  }
})();

/* ---------- coleção: filtros ---------- */
function initFacets() {
  const facets = $('[data-ap-facets]');
  if (!facets) return;
  const form = $('form', facets);
  $$('[data-ap-facets-open]').forEach((b) => b.addEventListener('click', () => openDrawer(facets, b)));
  const autoSubmit = () => !window.matchMedia('(max-width: 1000px)').matches;
  form?.addEventListener('change', (e) => {
    if (e.target.matches('input[type=checkbox]') && autoSubmit()) submitFacets(form);
  });
  form?.addEventListener('submit', (e) => { e.preventDefault(); submitFacets(form); });
  $$('[data-ap-sort]').forEach((s) => s.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  }));
}
function submitFacets(form) {
  const params = new URLSearchParams(new FormData(form));
  for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
  const sort = new URL(window.location.href).searchParams.get('sort_by');
  if (sort) params.set('sort_by', sort);
  window.location.href = `${form.action || window.location.pathname}?${params.toString()}`;
}

/* ---------- recomendações (Complete seu carro) ---------- */
function initRecommendations(scope = document) {
  $$('[data-ap-recs]', scope).forEach((sec) => {
    if (sec.dataset.apReady || sec.querySelector('.ap-carousel')) return;
    sec.dataset.apReady = '1';
    const load = () => fetch(sec.dataset.url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-ap-recs]');
      if (fresh && fresh.querySelector('.ap-card')) { sec.innerHTML = fresh.innerHTML; init(sec); }
      else sec.hidden = true;
    }).catch(() => { sec.hidden = true; });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(sec);
    } else load();
  });
}

/* ---------- página de produto (seção ap-main-product) ---------- */
function initPdp(scope = document) {
  $$('[data-ap-pdp]', scope).forEach((root) => {
    if (root.dataset.apReady) return;
    root.dataset.apReady = '1';
    let product = null;
    try { product = JSON.parse($('[data-ap-product-json]', root).textContent); } catch { return; }

    /* galeria */
    const track = $('[data-ap-track]', root);
    const slides = $$('.ap-pdp__slide', root);
    const thumbs = $$('.ap-pdp__thumb', root);
    const now = $('[data-ap-gal-now]', root);
    let current = Number(root.dataset.start) || 0;
    const setActive = (i) => {
      current = i;
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      if (now) now.textContent = String(i + 1);
      thumbs[i]?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
    };
    const goTo = (i, smooth = true) => {
      if (!track || !slides.length) return;
      const n = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(n);
    };
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.index))));
    $$('[data-ap-gal]', root).forEach((b) => b.addEventListener('click', () => goTo(current + Number(b.dataset.apGal))));
    if (track) {
      let raf = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current && slides[i]) setActive(i);
        });
      }, { passive: true });
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      });
      if (current) requestAnimationFrame(() => goTo(current, false));
    }

    /* variantes */
    const fieldsets = $$('[data-ap-option]', root);
    const idInput = $('[data-ap-variant-id]', root);
    const selected = () => fieldsets.map((fs) => $('input:checked', fs)?.value);
    const matches = (v, vals, skip = -1) => v.options.every((o, i) => i === skip || vals[i] === undefined || o === vals[i]);
    const markAvailability = (vals) => {
      fieldsets.forEach((fs, p) => {
        $$('input', fs).forEach((input) => {
          const test = vals.slice(); test[p] = input.value;
          const ok = product.variants.some((v) => v.available && matches(v, test));
          input.nextElementSibling?.classList.toggle('is-na', !ok);
        });
      });
    };
    const update = (variant) => {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      const box = $('[data-ap-price]', root);
      if (box) renderPrice(box, variant.price, variant.compare_at_price || 0);
      const onSale = (variant.compare_at_price || 0) > variant.price;
      $$('[data-ap-sale-only]', root).forEach((el) => { el.hidden = !onSale; });
      const off = $('[data-ap-pdp-off]', root);
      if (off) { off.hidden = !onSale; if (onSale) off.textContent = `-${Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)}%`; }
      $$('[data-ap-buy]', root).forEach((btn) => {
        btn.disabled = !variant.available;
        const label = $('[data-ap-buy-label]', btn);
        if (label) label.textContent = variant.available ? label.dataset.on : 'Esgotado';
      });
      fieldsets.forEach((fs, p) => { const out = $('[data-ap-option-value]', fs); if (out) out.textContent = variant.options[p]; });
      if (variant.featured_media) {
        const i = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
        if (i >= 0) goTo(i);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      markAvailability(variant.options);
    };
    root.addEventListener('change', (e) => {
      const fs = e.target.closest('[data-ap-option]');
      if (!fs) return;
      const vals = selected();
      const p = Number(fs.dataset.apOption);
      let variant = product.variants.find((v) => matches(v, vals));
      if (!variant) {
        /* combinação inexistente: mantém a opção clicada e escolhe a primeira variante compatível */
        variant = product.variants.find((v) => v.available && v.options[p] === vals[p]) || product.variants.find((v) => v.options[p] === vals[p]);
        if (variant) fieldsets.forEach((f, k) => { const input = $$('input', f).find((x) => x.value === variant.options[k]); if (input) input.checked = true; });
      }
      update(variant);
    });
    if (fieldsets.length) markAvailability(selected());
  });
}

/* quantidade (+/-) */
document.addEventListener('click', (e) => {
  const step = e.target.closest?.('[data-ap-qty-step]');
  if (!step) return;
  const input = $('input', step.closest('[data-ap-qty]'));
  if (!input) return;
  input.value = String(Math.max(1, (Number(input.value) || 1) + Number(step.dataset.apQtyStep)));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* Comprar agora: adiciona e vai direto ao checkout */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest?.('[data-ap-buy-now]');
  if (!btn) return;
  const form = btn.closest('form');
  const items = form ? formItems(form) : [];
  if (!items.length) return;
  btn.disabled = true; btn.classList.add('is-loading');
  try {
    const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Não foi possível continuar.');
    window.location.href = (window.Shopify?.routes?.root || '/') + 'checkout';
  } catch (err) {
    btn.disabled = false; btn.classList.remove('is-loading');
    let msg = form.querySelector('.ap-form-error');
    if (!msg) { msg = document.createElement('p'); msg.className = 'ap-form-error'; msg.setAttribute('role', 'alert'); msg.style.cssText = 'margin-top:8px;font-size:12px;color:#b80500'; form.appendChild(msg); }
    msg.textContent = err.message || 'Não foi possível continuar.';
  }
});

/* ---------- init ---------- */
function init(scope = document) {
  initReveal(scope); initAnnouncements(scope); initCarousels(scope); initGuides(scope); initHero(scope); initPdp(scope);
}
initHeader(); initDrawers(); initFooter(); initFacets(); init(); initRecommendations();
/* Editor de temas: reinicializa seções recarregadas */
document.addEventListener('shopify:section:load', (e) => { init(e.target); initRecommendations(e.target); });
